import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {

  @Input() allowDecimal = false;
  @Input() decimalPlaces = 0;

  @HostBinding('autocomplete') public autocomplete = 'off';
  constructor() {
    this.autocomplete = 'off';
  }

  private get isDecimalAllowed(): boolean {
    return this.allowDecimal || this.decimalPlaces > 0;
  }

  @HostListener('keypress', ['$event']) public disableKeys(e) {
    const keyCode = e?.keyCode ?? e?.which;
    const input = e?.target as HTMLInputElement;

    if (keyCode === 8) {
      return true;
    }
    if (keyCode >= 48 && keyCode <= 57) {
      if (this.isDecimalAllowed && input?.value?.includes('.') && this.decimalPlaces > 0) {
        const decimalIndex = input.value.indexOf('.');
        const selectionStart = input.selectionStart ?? input.value.length;
        const decimalPart = input.value.split('.')[1] ?? '';
        if (selectionStart > decimalIndex && decimalPart.length >= this.decimalPlaces) {
          return false;
        }
      }
      return true;
    }
    if (this.isDecimalAllowed && keyCode === 46) {
      return !input?.value?.includes('.');
    }
    return false;
  }

  @HostListener('paste', ['$event']) public onPaste(e) {
    e.preventDefault();
    const clipboardData = e?.clipboardData || (e.originalEvent && e?.originalEvent?.clipboardData);
    const pastedText = clipboardData.getData('text/plain');
    const sanitizedText = this.isDecimalAllowed
      ? this.sanitizeDecimalValue(pastedText)
      : pastedText.replace(/[^0-9]/g, '');
    document.execCommand('insertText', false, sanitizedText);
  }

  @HostListener('input', ['$event']) public onInput(e) {
    const input = e?.target as HTMLInputElement;
    input.value = this.isDecimalAllowed
      ? this.sanitizeDecimalValue(input?.value)
      : input?.value.replace(/[^0-9]/g, '');
  }

  private sanitizeDecimalValue(value: string): string {
    const sanitized = value.replace(/[^0-9.]/g, '');
    const parts = sanitized.split('.');
    if (parts.length <= 1) {
      return sanitized;
    }
    const decimalPart = parts.slice(1).join('');
    const limitedDecimal = this.decimalPlaces > 0
      ? decimalPart.slice(0, this.decimalPlaces)
      : decimalPart;
    return `${parts[0]}.${limitedDecimal}`;
  }

}
